import * as React from "react";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../StepShipping/actions.js";
import { getInvoiceFormData, isPrefillFinished } from "../../../StepShipping/selectors.js";
import { TitleWithIcon } from "../../../../components/TitleWithIcon/components/TitleWithIcon/TitleWithIcon.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const InvoiceFormComponent = ({ title }) => {
  const dispatch = useDispatch();
  const invoiceDetailsInitialData = useSelector(getInvoiceFormData);
  const isInvoiceFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Invoice);
  const isPrefillFinished$1 = useSelector(isPrefillFinished);
  const handleChange = React.useCallback(
    (formData) => {
      dispatch(updateShippingDetails({ form: formData }));
    },
    [dispatch]
  );
  if (!isInvoiceFormAvailable) return null;
  if (!invoiceDetailsInitialData || !isPrefillFinished$1) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "newsletter", label: title }), /* @__PURE__ */ React.createElement(
    CheckoutForm,
    {
      formName: "invoice",
      "data-t": "invoice",
      initialFormState: invoiceDetailsInitialData,
      onChange: handleChange
    },
    /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.Invoice })
  ));
};
export {
  InvoiceFormComponent
};
//# sourceMappingURL=InvoiceForm.js.map
